export enum EReviewsTagType {
  REVIEWS = 'reviews',
}
